import { Button, Navbar, NavbarBrand, NavbarContent, NavbarItem } from "@heroui/react";
import { signOut } from "aws-amplify/auth";
import Logo from "./Logo";
import { GrFormPreviousLink } from "react-icons/gr";
import { useNavigate, useLocation, Link } from 'react-router-dom';

export default function App() {
    const navigate = useNavigate();
    const location = useLocation(); // Get the current location

    // const handleBackButtonClick = () => {
    //     navigate('/'); // Redirect to the home page ("/")
    // };

    const handleBackButtonClick = () => {
        navigate(-1); // Navigate to the previous page
    };

    const handleLogout = async (): Promise<void> => {
        try {
            await signOut();
        } catch (error) {
            console.log('Error signing out: ', error);
        }
    };

    return (
        <Navbar isBordered className="relative" maxWidth="lg">
            {/* Left: Back arrow (conditionally rendered) */}
            <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                {location.pathname !== '/' && (
                    <GrFormPreviousLink size="30" color="#00819e" onClick={handleBackButtonClick} />
                )}
            </div>

            {/* Center: Logo */}
            <NavbarBrand className="flex justify-center mx-auto">
                <div className="w-48 md:w-64 lg:w-80 flex items-center justify-center">
                    <Link to="/">
                    <Logo/>
                    </Link>
                </div>
                <p className="sr-only">Cyrenians</p>
            </NavbarBrand>

            {/* Right: Logout Button */}
            <NavbarContent justify="end" className="absolute right-4 top-1/2 transform -translate-y-1/2">
                <NavbarItem>
                    <Button color="default" variant="faded" onPress={handleLogout}>
                        Logout
                    </Button>
                </NavbarItem>
            </NavbarContent>
        </Navbar>
    );
}
